import styled from 'styled-components'

export const CryptoPreviewWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  width: 100%;
  max-width: 50rem;

  background-color: white;

  font-size: 1.4rem;

  margin: 2rem 0;
  padding: 2rem;
  border-radius: 8px;

  @media (min-width: 500px) {
    padding: 3rem 5rem 4rem;
  }

  .label-value-wrapper {
    width: 100%;

    .label {
      font-size: 1.3rem;
      font-weight: 500;
      margin-bottom: 0.6rem;
    }

    .value {
    }

    .copy-box {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      gap: 2rem;

      border: 1px solid rgb(225, 230, 234);
      border-radius: 1rem;
      padding: 1rem 1rem 1rem 1.6rem;

      .copy-button {
        cursor: pointer;
        color: rgb(129, 131, 137);
        font-size: 1.2rem;
        font-weight: 500;
        padding: 6px 8px;
        border-radius: 4px;
        background-color: rgb(225, 229, 234);
        white-space: nowrap;
      }

      .value {
        white-space: normal;
        word-break: break-all;
        overflow-wrap: anywhere;
      }
    }
  }
`

export const CryptoPreviewTitle = styled.div`
  width: 100%;
  color: black;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: normal;
  line-height: 2.9rem;
  text-align: center;

  margin-bottom: 2rem;
`

export const WarningMessageWrapper = styled.div`
  background: rgba(30, 99, 255, 0.08);
  padding: 1.5rem;
  margin: 0 0 3rem;

  color: #454a54;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const WarningMessageTitle = styled.div`
  margin-bottom: 1rem;
  text-align: center;
  width: 100%;

  display: flex;
  align-items: center;
  justify-items: flex-start;

  color: black;
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: 2rem;

  img,
  svg {
    margin-right: 1rem;
  }
`
